import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useSetIncludedEntities = () => {
  const setIncludedEntities = useEntityDetailsDataStore(
    (state) => state.setIncludedEntities,
  );
  return setIncludedEntities;
};
